import $ from 'jquery';
import { Autoplay, Navigation, Pagination, Swiper } from 'swiper';

import { $Elements, Events } from './constants';

$Elements.document.on(Events.page.enter, () => {

	// ---------- Header Carousel ----------

	$('.header-carrousel-section .section-carousel').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: 2500,
				loop: true,
				observer: true,
				modules: [Navigation, Pagination, Autoplay],
				autoplay: {
					delay: 5000,
					disableOnInteraction: false
				},
				pagination: {
					el: this.querySelector('.swiper-pagination'),
					type: "progressbar",
				},
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
			});

			const indexCarousel = this.querySelector('.index-carrousel');
			const numbersPagination = indexCarousel.querySelectorAll('span');
			numbersPagination.forEach((number, index) => {
				number.addEventListener('click', () => {
					swiper.slideToLoop(index);
				});
			});

			swiper.on('slideChange', () => {
				numbersPagination.forEach((number, index) => {
					number.classList.toggle('active', index === swiper.realIndex);
				});
			});

			numbersPagination[swiper.realIndex].classList.add('active');

		}
	});

	// ---------- References Carousel ----------

	$('.references-section .section-carousel').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: 3000,
				slidesPerView: 'auto',
				slidesPerColumn: 2,
				grabCursor: false,
				autoplay: {
					delay: 1,
					disableOnInteraction: false
				},
				modules: [Autoplay],
				loop: true,
				observer: true,
				freeMode: true,
			});
		}
	});

	// ---------- Carousel ----------

	// $('.content-section .section-carousel, .content-section .column-carousel').each(function() {
	//
	// 	if(!this.swiper) {
	//
	// 		const swiper = new Swiper(this, {
	// 			speed: TransitionDurations.default,
	// 			loop: true,
	// 			observer: true,
	// 			modules: [Navigation, Pagination],
	// 			pagination: {
	// 				el: this.querySelector('.swiper-pagination'),
	// 			},
	// 			navigation: {
	// 				nextEl: this.querySelector('.swiper-button-next'),
	// 				prevEl: this.querySelector('.swiper-button-prev'),
	// 			},
	// 		});
	// 	}
	// });

	// ---------- Slideshow ----------

	// $('.content-section .section-slideshow, .content-section .column-slideshow').each(function() {
	//
	// 	if(!this.swiper) {
	//
	// 		const swiper = new Swiper(this, {
	// 			speed: TransitionDurations.default,
	// 			loop: true,
	// 			observer: true,
	// 			autoplay: true,
	// 			effect: 'fade',
	// 			modules: [Autoplay, EffectFade, Navigation, Pagination],
	// 			fadeEffect: {
	// 				crossFade: true,
	// 			},
	// 			pagination: {
	// 				el: this.querySelector('.swiper-pagination'),
	// 			},
	// 			navigation: {
	// 				nextEl: this.querySelector('.swiper-button-next'),
	// 				prevEl: this.querySelector('.swiper-button-prev'),
	// 			},
	// 		});
	// 	}
	// });
});
